import { NewDateTimeFormat, currencyFormat } from '../../../Functions';
export function CargoTransferSlipHeaDCompose(page, rowL, cts, dataUrl) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 140;
    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 50, 18);

    _y += _space * 2;

    return _y;
}

export function CargoTransferSlipHeadingCompose(page, rowL, cts, data) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    let current_datetime = new Date();
    // let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()
    if(data && data.length > 1){
        doc.setFont("times", "bold");
        doc.text('CARGO TRANSFER SLIP', 110, _y, null, null, 'center');
        _y += _space;
        doc.text('TANDEM', 110, _y, null, null, 'center');
        doc.setFont("times", "normal");
    
        _y += _space * 2;
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Date:');
        doc.setFont("times", "normal");
        doc.text(40, _y, NewDateTimeFormat(current_datetime));
    
        doc.setFont("times", "bold");
        doc.text(130, _y, 'Branch:');
        doc.setFont("times", "normal");
        doc.text(150, _y, data[0].branchName ? data[0].branchName : '');
        // doc.setFont("times", "bold");
        // doc.text(130, _y, 'Booking Reference:');
        // doc.setFont("times", "normal");
        // doc.text(175, _y, data[0].bookingRef ? data[0].bookingRef : '');
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'CTS No.:');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].ctsNum ? data[0].ctsNum : '');
    
        // doc.setFont("times", "bold");
        // doc.text(130, _y, 'Branch:');
        // doc.setFont("times", "normal");
        // doc.text(150, _y, data[0].branchName ? data[0].branchName : '');
    
        _y += _space * 2;
    }
    else {
        doc.setFont("times", "bold");
        doc.text('CARGO TRANSFER SLIP', 110, _y, null, null, 'center');
        doc.setFont("times", "normal");
    
        _y += _space * 2;
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Date:');
        doc.setFont("times", "normal");
        doc.text(40, _y, NewDateTimeFormat(current_datetime));
    
        doc.setFont("times", "bold");
        doc.text(130, _y, 'Booking Reference:');
        doc.setFont("times", "normal");
        doc.text(175, _y, data[0].bookingRef ? data[0].bookingRef : '');
    
        _y += _space;
    
        doc.setFont("times", "bold");
        doc.text(20, _y, 'CTS No:');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].ctsNum ? data[0].ctsNum : '');
    
        doc.setFont("times", "bold");
        doc.text(130, _y, 'Branch:');
        doc.setFont("times", "normal");
        doc.text(150, _y, data[0].branchName ? data[0].branchName : '');
    
        _y += _space * 2;
    }

    return _y;
}

export function CargoTransferSlipContentCompose(page, rowL, cts, data, containerPic) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    if(data && data.length > 1) {
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Trucker:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].truckerName ? data[0].truckerName : '');
        doc.line(55, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Plate Number:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].plateNum ? data[0].plateNum : '');
        doc.line(55, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Driver:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].driver ? data[0].driver : '');
        doc.line(55, _y + 1, 195, _y + 1);

        _y += _space * 2;
      
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Booking Reference:');
        doc.setFont("times", "normal");
        doc.text(65, _y, data[0].bookingRef ? data[0].bookingRef : '');

        doc.setFont("times", "bold");
        doc.text(115, _y, 'Booking Reference:');
        doc.setFont("times", "normal");
        doc.text(160, _y, data[1].bookingRef ? data[1].bookingRef : '');
       
        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Van No.');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].containerVan ? data[0].containerVan : '');
        doc.line(40, _y + 1, 100, _y + 1);

        doc.setFont("times", "bold");
        doc.text(115, _y, 'Van No.');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[1].containerVan ? data[1].containerVan : '');
        doc.line(135, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Seal No.');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].sealNum ? data[0].sealNum : '');
        doc.line(40, _y + 1, 100, _y + 1);

        doc.setFont("times", "bold");
        doc.text(115, _y, 'Seal No.');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[1].sealNum ? data[1].sealNum : '');
        doc.line(135, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Status');
        doc.setFont("times", "normal");
        // doc.text(40, _y, data[0].bookingStatus ? data[0].bookingStatus : '');
        doc.text(40, _y, data[0].containerStatus ? data[0].containerStatus : '');
        doc.line(40, _y + 1, 100, _y + 1);

        doc.setFont("times", "bold");
        doc.text(115, _y, 'Status');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[1].containerStatus ? data[1].containerStatus : '');
        doc.line(135, _y + 1, 195, _y + 1);

        _y += _space;
        
        let r_y = 0;
        if(data[0].containerStatus === 'Damaged' || data[1].containerStatus === 'Damaged'){
            var imageX = 60;
            doc.addImage(containerPic, 'PNG', imageX, _y, 100, 70);
            _y += _space * 15;
        }
        if(data[0].containerStatus === 'Damaged'){
            r_y = _y;
            doc.setFont("times", "bold");
            doc.text(20, _y, 'Damaged Part/s');
            doc.text(65, _y, 'Type of Damage');
            doc.setFont("times", "normal");
            doc.line(20, _y + 1, 110, _y + 1);
            _y += _space;
            if(data[0].damage && data[0].damage.length > 0){
                data[0].damage.forEach(element => {
                    doc.text(20, _y, element.vanParts);
                    doc.text(65, _y, element.damageType);
                    doc.line(20, _y + 1, 110, _y + 1);
                    _y += _space;
                });
            }
        }
        if(data[1].containerStatus === 'Damaged'){
            if(r_y > 0){
                _y = r_y;
            }
            doc.setFont("times", "bold");
            doc.text(110, _y, 'Damaged Part/s');
            doc.text(155, _y, 'Type of Damage');
            doc.setFont("times", "normal");
            doc.line(110, _y + 1, 195, _y + 1);
            _y += _space;
            if(data[1].damage && data[1].damage.length > 0){
                data[1].damage.forEach(element => {
                    doc.text(110, _y, element.vanParts);
                    doc.text(155, _y, element.damageType);
                    doc.line(110, _y + 1, 195, _y + 1);
                    _y += _space;
                });
            }
        }

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'From');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].fromCyName ? data[0].fromCyName : '');
        doc.line(40, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'To');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].toShipperName ? data[0].toShipperName : '');
        doc.line(40, _y + 1, 195, _y + 1);

        _y += _space;
        
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Remarks');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].remarks ? data[0].remarks : '');
        doc.line(40, _y + 1, 195, _y + 1);

        _y += _space * 2;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Van Locator');
        doc.setFont("times", "normal");
        doc.text(47, _y, data[0].vanLocator ? data[0].vanLocator : '');
        doc.line(47, _y + 1, 85, _y + 1);

        doc.setFont("times", "bold");
        doc.text(90, _y, 'Van Locator Amount');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[0].vanLocatorAmount ? currencyFormat(data[0].vanLocatorAmount) : '');
        doc.line(135, _y + 1, 195, _y + 1);

        _y += _space;
    }
    else {
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Trucker:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].truckerName ? data[0].truckerName : '');
        doc.line(55, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Plate Number:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].plateNum ? data[0].plateNum : '');
        doc.line(55, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Driver:');
        doc.setFont("times", "normal");
        doc.text(55, _y, data[0].driver ? data[0].driver : '');
        doc.line(55, _y + 1, 195, _y + 1);

        _y += _space * 2;
      
        doc.setFont("times", "bold");
        doc.text(20, _y, 'Van No.');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].containerVan ? data[0].containerVan : '');
        doc.line(40, _y + 1, 85, _y + 1);

        doc.setFont("times", "bold");
        doc.text(90, _y, 'From');
        doc.setFont("times", "normal");
        doc.text(110, _y, data[0].fromCyName ? data[0].fromCyName : '');
        doc.line(110, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Seal No.');
        doc.setFont("times", "normal");
        doc.text(40, _y, data[0].sealNum ? data[0].sealNum : '');
        doc.line(40, _y + 1, 85, _y + 1);

        doc.setFont("times", "bold");
        doc.text(90, _y, 'To');
        doc.setFont("times", "normal");
        doc.text(110, _y, data[0].toShipperName ? data[0].toShipperName : '');
        doc.line(110, _y + 1, 195, _y + 1);

        _y += _space;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Status');
        doc.setFont("times", "normal");
        // doc.text(40, _y, data[0].bookingStatus ? data[0].bookingStatus : '');
        doc.text(40, _y, data[0].containerStatus ? data[0].containerStatus : '');
        doc.line(40, _y + 1, 85, _y + 1);

        doc.setFont("times", "bold");
        doc.text(90, _y, 'Remarks');
        doc.setFont("times", "normal");
        doc.text(110, _y, data[0].remarks ? data[0].remarks : '');
        doc.line(110, _y + 1, 195, _y + 1);

        _y += _space * 2;

        doc.setFont("times", "bold");
        doc.text(20, _y, 'Van Locator');
        doc.setFont("times", "normal");
        doc.text(47, _y, data[0].vanLocator ? data[0].vanLocator : '');
        doc.line(47, _y + 1, 85, _y + 1);

        doc.setFont("times", "bold");
        doc.text(90, _y, 'Van Locator Amount');
        doc.setFont("times", "normal");
        doc.text(135, _y, data[0].vanLocatorAmount ? currencyFormat(data[0].vanLocatorAmount) : '');
        doc.line(135, _y + 1, 195, _y + 1);

        _y += _space;

        if(data[0].containerStatus === 'Damaged'){
            var imageX2 = 60;
            doc.addImage(containerPic, 'PNG', imageX2, _y, 100, 70);
            _y += _space * 15;

            doc.setFont("times", "bold");
            doc.text(60, _y, 'Damaged Part/s');
            doc.text(140, _y, 'Type of Damage');
            doc.setFont("times", "normal");
            doc.line(20, _y + 1, 195, _y + 1);
            _y += _space;
            if(data[0].damage && data[0].damage.length > 0){
                data[0].damage.forEach(element => {
                    doc.text(30, _y, element.vanParts);
                    doc.text(120, _y, element.damageType);
                    doc.line(20, _y + 1, 195, _y + 1);
                    _y += _space;
                });
            }
            _y += _space;
        }
    }

    return _y;
}

export function CargoTransferSlipClosingCompose(page, rowL, cts, user, data) {
    var doc = cts;
    var _y = rowL;
    var _space = page.spacingunit;

    _y += _space;

    var c0002, c0003, splitFirst;

    var ct2 = data[0].terms ? data[0].terms.find((TC) => TC.code === "C0002" || TC.policyCode === "C0002") : undefined;

    if(ct2 && ct2.requestValueInDecimal && ct2.requestValueInDecimal > 0){ c0002 = ct2.requestValueInDecimal; } 
    else if(ct2 && ct2.stdValueInDecimal && ct2.stdValueInDecimal > 0){ c0002 = ct2.stdValueInDecimal; } 
    else if(ct2 && ct2.requestedValueInDecimal && ct2.requestedValueInDecimal > 0){ c0002 = ct2.requestedValueInDecimal; } 
    else if(ct2 && ct2.stdValueInDecimalApplied && ct2.stdValueInDecimalApplied > 0){ c0002 = ct2.stdValueInDecimalApplied; } 
    else { c0002 = 0; }
    // c0002 = ct2 !== undefined && ct2.requestValueInDecimal && ct2.requestValueInDecimal !== 0 && ct2.requestValueInDecimal ? ct2.requestValueInDecimal :
    //     ct2 !== undefined && ct2.stdValueInDecimal && ct2.stdValueInDecimal !== 0 ? ct2.stdValueInDecimal : 
    //     ct2 !== undefined && ct2.requestedValueInDecimal && ct2.requestedValueInDecimal !== 0 ? ct2.requestedValueInDecimal : 
    //     ct2 !== undefined && ct2.stdValueInDecimalApplied && ct2.stdValueInDecimalApplied !== 0 ? ct2.stdValueInDecimalApplied : 0;


    var ct3 = data[0].terms ? data[0].terms.find((TC) => TC.code === "C0003" || TC.policyCode === "C0003") : undefined;

    if(ct3 && ct3.requestValueInDecimal && ct3.requestValueInDecimal > 0){ c0003 = ct3.requestValueInDecimal; } 
    else if(ct3 && ct3.stdValueInDecimal && ct3.stdValueInDecimal > 0){ c0003 = ct3.stdValueInDecimal; } 
    else if(ct3 && ct3.requestedValueInDecimal && ct3.requestedValueInDecimal > 0){ c0003 = ct3.requestedValueInDecimal; } 
    else if(ct3 && ct3.stdValueInDecimalApplied && ct3.stdValueInDecimalApplied > 0){ c0003 = ct3.stdValueInDecimalApplied; } 
    else { c0003 = 0; }
    // c0003 = ct3 !== undefined && ct3.requestValueInDecimal && ct3.requestValueInDecimal !== 0 && ct3.requestValueInDecimal ? ct3.requestValueInDecimal :
    //     ct3 !== undefined && ct3.stdValueInDecimal && ct3.stdValueInDecimal !== 0 ? ct3.stdValueInDecimal : 
    //     ct3 !== undefined && ct3.requestedValueInDecimal && ct3.requestedValueInDecimal !== 0 ? ct3.requestedValueInDecimal : 
    //     ct3 !== undefined && ct3.stdValueInDecimalApplied && ct3.stdValueInDecimalApplied !== 0 ? ct3.stdValueInDecimalApplied : 0 ;

    if (c0003 > 0) {
        splitFirst = doc.splitTextToSize('NOTE: Please return the container/s within (' + c0002 + ') days, to avoid payment of '
            + 'demurrage charges at Php ' + currencyFormat(c0003) + ' per day exceeding the number of allowable free storage.'
            , page.maxWidthInPoint);
    }
    else {
        splitFirst = doc.splitTextToSize('NOTE: Please return the container/s within (' + c0002 + ') days, to avoid payment of '
            + 'demurrage charges at Php ' + c0003 + ' per day exceeding the number of allowable free storage.'
            , page.maxWidthInPoint);
    }

    doc.text(20, _y, splitFirst);
    _y += (_space * splitFirst.length);

    _y += _space;

    doc.text(20, _y, 'Issued By:');
    doc.text(45, _y, user.name ? user.name : '');
    doc.line(45, _y + 1, 95, _y + 1);

    doc.text(100, _y, 'Received By:');
    doc.line(130, _y + 1, 190, _y + 1);
    _y += _space * 1.2;
    doc.text(130, _y, 'Signature over Printed Name');

    _y += _space * 2;
    return _y;
}